import React from 'react';
import { useSelector } from 'react-redux';
import { getFirstName } from 'Shared/helpers';

import { getWorkspaceTeammateById } from 'Shared/selectors/workspace';
import ModalHeaderWithAvatar from 'Shared/components/modals/ModalsComponents/ModalHeaderWithAvatar/ModalHeaderWithAvatar';

import kudosIllustration from './kudosIllustration.png';

type Props = {
  onModalToggle?(): void;
  isGroup: boolean;
  teammateId: number;
  isEditFeedback: boolean;
  workspaceName: string;
};

const defaultAvatar = { profilePictureUrl: kudosIllustration };

export default function Header({ onModalToggle, isGroup, isEditFeedback, workspaceName, teammateId }: Props) {
  const teammate = useSelector(getWorkspaceTeammateById(teammateId));

  const avatar = isGroup ? null : teammate?.avatar || defaultAvatar;
  const firstName = teammate?.firstName || getFirstName(workspaceName || '') || '';

  const title = isGroup ? 'Give kudos' : `Give ${firstName} kudos`;

  const description = isGroup
    ? 'Share some positive feedback! This will appear in this workspace for all the collaborators to see how awesome they are.'
    : `Share some positive feedback on something they’ve done recently! This will appear in your private workspace with ${firstName}.`;

  return (
    <ModalHeaderWithAvatar
      onToggle={onModalToggle}
      title={isEditFeedback ? 'Edit kudos' : title}
      description={description}
      avatar={avatar}
    />
  );
}
